import { useMemo, useState } from "react";
import { useClosetStore } from "./state/store";
import { ControlsPanel } from "./components/ControlsPanel";
import { ClosetPreview } from "./components/ClosetPreview";
import { CutSheet } from "./components/CutSheet";
import { generateParts } from "./domain/parts";
import { packParts, summarize } from "./domain/cutPlan";

type Tab = "3d" | "cut";

export function App(): JSX.Element {
  const spec = useClosetStore((s) => s.spec);
  const [tab, setTab] = useState<Tab>("3d");

  const parts = useMemo(() => generateParts(spec), [spec]);
  const sheets = useMemo(
    () =>
      packParts(
        parts,
        spec.material.sheetWidth,
        spec.material.sheetLength,
        spec.material.kerf,
      ),
    [
      parts,
      spec.material.sheetWidth,
      spec.material.sheetLength,
      spec.material.kerf,
    ],
  );
  const summary = useMemo(() => summarize(sheets), [sheets]);

  return (
    <div className="app">
      <ControlsPanel />
      <main className="main">
        <header className="topbar">
          <h1>Closet Maker</h1>
          <nav>
            <button
              className={tab === "3d" ? "on" : ""}
              onClick={() => setTab("3d")}
            >
              3D Preview
            </button>
            <button
              className={tab === "cut" ? "on" : ""}
              onClick={() => setTab("cut")}
            >
              Cut Plan
            </button>
          </nav>
          <div className="summary">
            <span>{summary.partCount} parts</span>
            <span>{summary.sheetCount} sheets</span>
            <span>{summary.wastePercent.toFixed(1)}% waste</span>
            <button onClick={() => window.print()}>Print</button>
          </div>
        </header>
        <section className="viewport">
          {tab === "3d" ? (
            <ClosetPreview spec={spec} />
          ) : (
            <CutSheet sheets={sheets} />
          )}
        </section>
      </main>
    </div>
  );
}
